import { pipe } from 'fp-ts/function';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { LocalizedText, LocalizedDateTime, withAppClockService } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { asyncContainerFactory, Empty } from '@mews-commander/ui';
import { Table } from '@mews-commander/ui/legacy';
import {
    areTasksFetching,
    hasTasksFailed,
    getSortedMappedTasksByServiceOrderIds,
    areCheckedReservationsFromMultipleServices,
} from '../../selectors';
import TaskName from './TaskName';
import TaskStateTag from './TaskStateTag';
import TaskContextMenu from './TaskContextMenu';
import ServiceName from './ServiceName';

const servicesMapping = {
    valueKey: 'service',
    title: <LocalizedText textKey={TextKey.Service} />,
    render: ({ serviceOrderId }: $TSFixMe) => <ServiceName serviceOrderId={serviceOrderId} />,
    columnWidth: '20%',
};

const createTableMapping = ({ areCheckedMultipleServices }: $TSFixMe) => [
    {
        valueKey: 'name',
        title: <LocalizedText textKey={TextKey.Name} />,
        render: ({ name, id }: $TSFixMe) => <TaskName name={name} id={id} />,
        columnWidth: areCheckedMultipleServices ? '40%' : '60%',
    },
    ...(areCheckedMultipleServices ? [servicesMapping] : []),
    {
        valueKey: 'deadline',
        title: <LocalizedText textKey={TextKey.Deadline} />,
        render: ({ deadlineDateTime }: $TSFixMe) => <LocalizedDateTime dateTime={deadlineDateTime} />,
        columnWidth: '20%',
    },
    {
        valueKey: 'status',
        title: <LocalizedText textKey={TextKey.Status} />,
        render: ({ temporalState }: $TSFixMe) => <TaskStateTag temporalState={temporalState} />,
        columnWidth: '10%',
    },
    {
        valueKey: 'actions',
        title: <LocalizedText textKey={TextKey.ActionPlural} />,
        render: ({ id, temporalState }: $TSFixMe) => <TaskContextMenu id={id} temporalState={temporalState} />,
        columnWidth: '10%',
    },
];

const TaskTable = ({ tasks, areCheckedMultipleServices }: $TSFixMe) => {
    if (!tasks.length) {
        return <Empty />;
    }
    const tableMapping = createTableMapping({ areCheckedMultipleServices });
    return <Table mapping={tableMapping} source={tasks} />;
};

export default pipe(
    TaskTable,
    asyncContainerFactory({ withOverlayedLoader: true }),
    connect(
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        createStructuredSelector({
            tasks: getSortedMappedTasksByServiceOrderIds,
            areCheckedMultipleServices: areCheckedReservationsFromMultipleServices,
            isFetching: areTasksFetching,
            hasFailed: hasTasksFailed,
        })
    ),
    withAppClockService
);
